<style lang="stylus" scoped>
    .excelcontext
        position absolute
        left 0
        top 0
        z-index 100
        .context-content
            padding 6px 0
</style>

<template>
    <div
        ref="menu"
        class="excelcontext menu-container"
        :style="{ left: `${fixPosition.left}px`, top: `${fixPosition.top}px` }"
        v-transfer-dom
        :data-transfer="true"
        v-click-outside="closeBox"
    >
        <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class ExcelContext extends Vue {
        @Prop()
        position;
        @Prop()
        menuType;

        get menuList() {
            let list = [
                { key: "col_Before", isRender: this.menuType == 0 },
                { key: "col_After", isRender: this.menuType == 0 },
                { key: "row_Before", isRender: this.menuType == 1 },
                { key: "row_After", isRender: this.menuType == 1 },
            ];

            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "context-content", list: resultList };
        }
        closeBox() {
            this.$emit("closeEvent");
        }
        handleClicks(...args) {
            let key = args[0];
            let data = key.split("_");
            this.$emit("handleContextEvent", data);
        }
        fixPosition = {
            left: 0,
            top: 0,
        };
        @Watch("position", { deep: true })
        fixPos(nv, ov) {
            const dom = this.$refs.menu as HTMLElement;
            let rect = dom.getBoundingClientRect();
            if (nv.left + rect.width > window.innerWidth) {
                this.fixPosition.left = window.innerWidth - rect.width;
            } else {
                this.fixPosition.left = nv.left;
            }
            if (nv.top + rect.height > window.innerHeight) {
                this.fixPosition.top = window.innerHeight - rect.height;
            } else {
                this.fixPosition.top = nv.top;
            }
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "col_Before": "在左侧插入列",
        "col_After": "在右侧插入列",
        "row_Before": "在上方插入行",
        "row_After": "在下方插入行"
    },
    "en": {
        "col_Before": "Insert Left",
        "col_After": "Insert Right",
        "row_Before": "Insert Above",
        "row_After": "Insert Below"
    },
    "fr": {
        "col_Before": "Insérer à gauche",
        "col_After": "Insérer à droite",
        "row_Before": "Insérer au dessus",
        "row_After": "Insérer au dessous"
    },
    "de": {
        "col_Before": "Links einfügen",
        "col_After": "Rechts einfügen",
        "row_Before": "Darüber einfügen",
        "row_After": "Darunter einfügen"
    },
    "jp": {
        "col_Before": "列の左に挿入",
        "col_After": "列の右に挿入",
        "row_Before": "行の前に挿入",
        "row_After": "行の後に挿入"
    },
    "es": {
        "col_Before": "Insertar a la izquierda",
        "col_After": "Insertar a la derecha",
        "row_Before": "Insertar abajo",
        "row_After": "Insertar debajo"
    },
    "pt": {
        "col_Before": "Inserir à Esquerda",
        "col_After": "Inserir à Direita",
        "row_Before": "Inserir Acima",
        "row_After": "Inserir Abaixo"
    },
    "it": {
        "col_Before": "Inserisci a Sinistra",
        "col_After": "Inserisci a Destra",
        "row_Before": "Inserisci Sopra",
        "row_After": "Inserisci Sotto"
    }
}
</i18n>
